/**
 * This is a class to store a single dependency from dependency list
 * The correct form of the dependency is field_name,<field_name_value>,<current_field_value>,[,<path>,]
 * Eg. rodzaj_klienta,2,1,[,3,5,8,12,]
 * The first index in path MUST be the index of the panel with dependency field
 * */

export default class Dependency {
    #fieldName;
    #fieldValue;
    #dependencyFieldValue;
    #path;

    constructor(dependenciesString) {
        const dependenciesArray = dependenciesString.split(',');
        this.#fieldName = dependenciesArray[0];
        this.#fieldValue = dependenciesArray[1];
        this.#dependencyFieldValue = dependenciesArray[2];
        if(dependenciesArray.length > 4) this.#path = dependenciesArray.slice(4, dependenciesArray.length - 1);
    }

    getFieldName() {
        return this.#fieldName;
    }

    getFieldValue() {
        return this.#fieldValue;
    }

    getDependencyFieldValue() {
        return this.#dependencyFieldValue;
    }

    getPath() {
        return this.#path ? this.#path : null;
    }
}